import { Checkbox, FormControlLabel } from "@mui/material";
import { ChangeEvent, FC } from "react";
import { useTranslation } from "react-i18next";

export interface ConsentToCollectUsageDataCheckboxProps {
  value: boolean | null | undefined;
  onChange: (value: boolean) => void;
}

export const ConsentToCollectUsageDataCheckbox: FC<
  ConsentToCollectUsageDataCheckboxProps
> = (props) => {
  const { t } = useTranslation("shared-ts-posthog");
  const handleConsentCheckboxChange = (
    event: ChangeEvent,
    checked: boolean
  ) => {
    props.onChange(checked);
  };

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={props.value ?? undefined}
          onChange={handleConsentCheckboxChange}
        />
      }
      label={t("I consent to collection of usage data")}
    />
  );
};
